import React from 'react';
import axios from 'axios';
import { ApiUrl } from '../conf/config';

export const useDeleteGroup = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const deleteGroup = (id: string) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    axios
      .delete(`${ApiUrl}/admin/api/v1/groups/${id}`, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { deleteGroup, loading, error };
};
